// @flow
import React, { Component } from 'react';

type Props = {
    content: Object,
    assetId: Number,
};

export default class Brightcove extends Component<Props> {
    render() {
        const { account_id, video_id } = this.props.content;
        if (account_id === '' || video_id === '') return null;

        const width = this.props.content.width || 750;
        const height = this.props.content.height || 420;
        const embedId = this.props.assetId;
        const playerId = 'default_default';
        return (
            <iframe
                id={`ls_embed_${embedId}`}
                src={`https://players.brightcove.net/${account_id}/${playerId}/index.html?videoId=${video_id}`}
                width={`${width}`}
                height={`${height}`}
                frameBorder="0"
                scrolling="no"
                allowFullScreen
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Brightcove.js